import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { DebugLogger } from 'lib/debugLogger';
import { IS_CORP_USER, IS_ONPREMISE, IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';
import { DUPLICATES_PAY_SOURCE } from 'reactApp/modules/duplicates/duplicates.constants';

/** https://jira.vk.team/browse/CLOUDWEB-20271 Удаление дубликатов. Верстка подраздела. */
export const IS_DUPLICATES_ENABLED = !IS_ONPREMISE && isFeature('is-duplicates-enabled');

/** id модалки точки входа в раздел дубликатов - для включения нужно будет включать фичу app.enableFeature('3promo-enable-duplicates-entry-point') */
export const DUPLICATES_ENTRY_POINT_MODAL_ID = 'duplicates-entry-point';

export const DUPLICATES_ENTRY_POINT_MODAL_CONFIG = getFeature(`${DUPLICATES_ENTRY_POINT_MODAL_ID}-config`) || {
    showLimit: 3,
    closeLimit: 3,
    showInterval: 60 * 60 * 24 * 2,
};

/** id модалки онбординга в разделе дубликатов - для включения нужно будет включать фичу app.enableFeature('3promo-enable-duplicates-onboarding') */
export const DUPLICATES_ONBOARDING_MODAL_ID = 'duplicates-onboarding';

export const DUPLICATES_ONBOARDING_MODAL_CONFIG = getFeature(`${DUPLICATES_ONBOARDING_MODAL_ID}-config`) || {
    showLimit: 3,
    closeLimit: 3,
    showInterval: 60 * 60 * 24 * 2,
};

type TariffsModalSettings = {
    title: string;
    tariffsNumber: string;
    activeTab: string;
};

const defaultModalSettings: TariffsModalSettings = {
    title: 'Почта без рекламы — и другие опции с подпиской Mail Space',
    tariffsNumber: '53',
    activeTab: 'm',
};

const nameShowAnalytics = 'modal-show';
const nameClickAnalytics = 'modal-click';

export const duplicatesLimitCount: number = getFeature('duplicates-limit-count') || 5;

export const duplicatesTariffs: TariffsModalSettings = getFeature('duplicates-tariffs');

export const duplicatesTariffsModal = {
    paySource: DUPLICATES_PAY_SOURCE,
    name: 'duplicates',
    enabled: !IS_CORP_USER && !IS_PAID_USER,
    buyTitle: duplicatesTariffs.title || defaultModalSettings.title,
    tariffsNumber: duplicatesTariffs.tariffsNumber || defaultModalSettings.tariffsNumber,
    activeTab: duplicatesTariffs.activeTab || defaultModalSettings.activeTab,
    actionShow: nameShowAnalytics,
    actionClick: nameClickAnalytics,
};

export const duplicatesRequestLimit = getFeature('duplicates-request-limit') || 5;

export const duplicatesBanner = isFeature('duplicates-banner');

export const duplicatesDebug = isFeature('duplicates-debug');
export const duplicatesDebugLogger = new DebugLogger({ DEBUG_SCOPE: 'DuplicatesDebug', DEBUG: duplicatesDebug });

export const DUPLICATES_ACTIVATION_ENABLED = getFeature('duplicates-activation');
